import { NoddiPhoneInput, NoddiPhoneInputProps } from '@ui-components/Inputs/NoddiPhoneInput';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = Omit<NoddiPhoneInputProps, 'value' | 'onChange'>;

export const TanstackFormPhoneInput = ({ label = 'Phone number', disableAutoFocus = true, ...rest }: Props) => {
  const field = useFieldContext<string>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiPhoneInput
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        onBlur={field.handleBlur}
        value={field.state.value ?? ''}
        onChange={(value: string) => field.handleChange(value)}
        disableAutoFocus={disableAutoFocus}
        label={label}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
